import { service } from '../../../../helpers/http'

//Retorna a lista com as categorias de grupos
export const ActionGetGroupBases = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupBase',
        action: 'getGroupBases',
        payload: payload
    })
    
}

//Cadastra uma nova categoria de grupo
export const ActionPostGroupBases = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupBase',
        action: 'postGroupBases',
        payload: payload
    })
    
}

//Atualiza uma categoria de grupo
export const ActionPutGroupBases = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupBase',
        action: 'putGroupBases',
        payload: payload
    })
    
}

//Deleta uma categoria de grupo
export const ActionDeleteGroupBases = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroupBase',
        action: 'deleteGroupBases',
        payload: payload
    })
    
}